'use client';

import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';

interface DashboardContextType {
  toggleMenu: boolean;
  setToggleMenu: (value: boolean) => void;
  hideMenu: boolean;
  setHideMenu: (value: boolean) => void;
}

const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

export const useDashboardProvider = (): DashboardContextType => {
  const context = useContext(DashboardContext);
  if (!context) throw new Error('useDashboard must be used within a DashboardProvider');
  return context;
};

export const DashboardProvider = ({ children }: { children: ReactNode }) => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [hideMenu, setHideMenu] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== 'undefined') {
        const width = document.documentElement.scrollWidth;
        console.log({ width });
        setToggleMenu(width <= 1535);
        setHideMenu(width <= 767);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <DashboardContext.Provider value={{ toggleMenu, setToggleMenu, hideMenu, setHideMenu }}>
      {children}
    </DashboardContext.Provider>
  );
};
